var Flickity = require('flickity');

var flkty = new Flickity('.related-news-desktop', {
    cellAlign: 'left',
    contain: true,
    groupCells: true,
    pageDots: false
});

const relatedNews = document.querySelector('.related-news-container');
const mobileContent = relatedNews.querySelector('.related-news-mobile');

window.onresize = setRelatedNewsContainerHeight;
setRelatedNewsContainerHeight();

function setRelatedNewsContainerHeight() {
    relatedNews.style.height = window.innerWidth < 1024 ?
        mobileContent.offsetHeight + 'px' :
        '480px';
}
